import { useSelector } from 'react-redux';

import selectors from '../flux/selectors.js';

const useFiatWidgetAvailability = (): {
  loading: boolean;
  available: boolean;
} => {
  const widgetAvailability = useSelector(selectors.fiatRamp.widgetAvailability);

  return {
    loading: !widgetAvailability?.loaded,
    available: !!widgetAvailability?.available,
  };
};

export default useFiatWidgetAvailability;
